module.exports = __webpack_public_path__ + "img/gradeX.f36a7052.png";